import React from 'react'
import { roleCellItemStyle, roleCellStyle } from './role-cell.style'
import { Box } from '@material-ui/core'

export const RoleCell = ({ data }) => {
	return (
		<Box css={roleCellStyle}>
			{data?.map((item, index) => (
				<Box key={index} css={roleCellItemStyle}>
					{item.name}
				</Box>
			))}
		</Box>
	)
}
